import { render, staticRenderFns } from "./ReviewStatistic.vue?vue&type=template&id=4db2fb03&"
import script from "./ReviewStatistic.vue?vue&type=script&lang=js&"
export * from "./ReviewStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports